import { resetRouter } from '@/router'

export function resetTokenAndClearUser() {
    // 退出登陆 清除用户资料
    localStorage.setItem('token', '')
    localStorage.setItem('userImg', '')
    localStorage.setItem('userName', '')
    // 重设路由
    resetRouter()
}

export const defaultDocumentTitle = 'vue-admin-template'
export function getDocumentTitle(pageTitle) {
    if (pageTitle) return `${defaultDocumentTitle} - ${pageTitle}`
    return `${defaultDocumentTitle}`
}

/**
 * 下载excel
 * @param  data  接口返回数据 res.data
 * @param res 接口返回数据 res
 * @returns excel文件
 */
export function exportExcel(data, res) {
    if (!data) {
      // 如果没有data数据就不进行操作
      return
    }
  
    // 获取headers中的filename文件名
    const tempName = res.headers['content-disposition']
      .split(';')[1]
      .split('filename=')[1]
    const fileName = decodeURI(tempName)
    const blob = new Blob([data], { type: 'application/vnd.ms-excel' }) // 转换成二进制对象
    if ('download' in document.createElement('a')) {
      // 不是IE浏览器
      const url = window.URL.createObjectURL(blob) // 二进制对象转换成url地址
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.setAttribute('download', fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link) // 下载完成移除元素
      window.URL.revokeObjectURL(url) // 释放掉blob对象
    } else {
      window.navigator.msSaveBlob(blob, fileName)
    }
  }